import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

interface UsePortfolioOnboardingAccessProps {
  hasPortfolioManagerOrganizationMembership: boolean
  isEnabled: boolean
}

export const usePortfolioOnboardingAccess = ({
  hasPortfolioManagerOrganizationMembership,
  isEnabled,
}: UsePortfolioOnboardingAccessProps) => {
  const navigate = useNavigate()
  const { pathname, state } = useLocation()

  const isOnPortfolioOnboardingPage = pathname === '/onboarding/portfolio'
  const isFromInvitation = state?.fromInvitation === true
  const shouldBlockPortfolioOnboarding =
    isEnabled &&
    isOnPortfolioOnboardingPage &&
    !hasPortfolioManagerOrganizationMembership &&
    !isFromInvitation

  useEffect(() => {
    if (!shouldBlockPortfolioOnboarding) {
      return
    }

    navigate('/holding', { replace: true })
  }, [navigate, shouldBlockPortfolioOnboarding])

  return {
    shouldBlockPortfolioOnboarding,
  }
}
